import { render, staticRenderFns } from "./SingersPage.vue?vue&type=template&id=9cd83282&scoped=true"
import script from "./SingersPage.vue?vue&type=script&lang=js"
export * from "./SingersPage.vue?vue&type=script&lang=js"
import style0 from "./SingersPage.vue?vue&type=style&index=0&id=9cd83282&prod&lang=css"
import style1 from "./SingersPage.vue?vue&type=style&index=1&id=9cd83282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd83282",
  null
  
)

export default component.exports